import React, {Component} from "react";
import Select from 'react-select'
import {map} from 'lodash';
import axios from 'axios';
import * as moment from 'moment';

export default class Notification extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            'notificationTypes': JSON.parse(this.props.notification_types),
            'notificationType': {value: 0, label: 'Не прочитані'},
            'notifications': null,
            'countNotifications': 0,
        };

        this.selectNotificationType = this.selectNotificationType.bind(this);
        this.readNotification = this.readNotification.bind(this);
        this.readAllNotification = this.readAllNotification.bind(this);
    }

    selectNotificationType(value) {
        this.setState({
            notificationType: value
        });

        this.getNotifications(value)
    }

    componentDidMount() {
        this.getNotifications(this.state.notificationType);
    }

    getNotifications(notificationType) {
            axios.get("/get-notifications", {
                params: {
                    notification_type_id: notificationType.value,
                }
            })
                .then(({data}) => {
                    this.setState({
                        notifications: data[0],
                        countNotifications: data[1]
                    })
            });
    }

    objectLenght (obj) {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    };

    readNotification(id) {
        axios.get("/read-notification/"+id).then(({data}) => {
            window.location.pathname = data;
        });
    }

    readAllNotification() {
        axios.get("/read-all-notification", {
            params: {
                ids: map(this.state.notifications, (notification, index) => {
                    return notification.id
                })
            },
        }).then(() => {
            this.getNotifications(this.state.notificationType);
        });
    }

    showAllNotification() {
        window.location.pathname = '/notifications';
    }

    render() {
        return (
            <li className="nav-item dropdown notification-dropdown">
                <a title="Повідомлення" className="nav-link dropdown-toggle d-flex flex-column align-items-center" href="#" id="dropdown03"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="fa icon fa-bell"></i>
                    {this.state.countNotifications ?
                        <span id="user-notifications-count" className="badge badge-pill badge-danger colored">{this.state.countNotifications}</span>
                        :
                        ''
                    }
                    <div className="info mt-1">
                        <div className="subtitle">Повідомлення</div>
                    </div>
                </a>
                <div className="dropdown-menu message-dropdown dropdown-menu-right" aria-labelledby="dropdown03">
                    <div className="row align-items-center p-3">
                        <div className="col-6">
                            <div className="c-title d-inline-block position-relative">
                                Повідомлення
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group mb-0">
                                <Select value={this.state.notificationType}
                                        className='react-select-container'
                                        classNamePrefix="react-select"
                                        onChange={this.selectNotificationType}
                                        placeholder={'Тип повідомлення'}
                                        options={map(this.state.notificationTypes, (notificationType, index) => {
                                            return {value: index, label: notificationType};
                                        })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="message-dropdown-list">
                        {this.objectLenght(this.state.notifications) ?
                            map(this.state.notifications, (notification, index) =>
                                <a key={index} onClick={() => {this.readNotification(notification.id)}} className={`messageBlock__link ${notification.read_at ? 'readed' : ''}`}>
                                    <div className="messageBlock__item">
                                        <div className="d-flex justify-content-between">
                                            <div className="messageBlock__item__title">{notification.data.title}</div>
                                            <div className="messageBlock__item__date">{moment(notification.created_at).format("DD.MM.YY")}</div>
                                        </div>
                                        <div className="messageBlock__item__message">{notification.data.text}</div>
                                    </div>
                                </a>
                            )
                            :
                            <div className="p-3">Немає повідомленнь</div>
                        }
                    </div>
                    <div className="row p-3">
                        <div className="col-6">
                            <button type="button" className="btn btn-primary" style={{lineHeight: 1}} onClick={this.readAllNotification}>Відзначити все як прочитані</button>
                        </div>
                        <div className="col-6">
                            <button type="button" className="btn btn-primary" style={{lineHeight: 1}} onClick={this.showAllNotification}>Переглянути всі повідомлення</button>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}
